/*
 * File: Like 点赞/取消点赞
 * Author: QuocVi<guowei2@huya.com>
 * Date: 2020-09-14
 */

import classnames from "classnames";
import React, { useState, useEffect, useCallback } from "react";
import styles from "./Like.scss?__local";
import { Icon, Modal, message } from "antd";
import getTT from "getTT";
import { useAction } from "@/hooks/useAction";
import { likeExt, unLikeExt } from "@/api/api";
import * as R from "ramda";

function Like(data) {
  const {
    data: { like, hadLike, extUuid },
  } = data;
  const [ishadLike, setHadLike] = useState(hadLike);
  const [likeNum, setLikeNum] = useState(like);

  const [likeState, performLike, resetLikeState] = useAction(likeExt);
  const [unLikeState, perfromUnLike, resetUnLikeState] = useAction(unLikeExt);

  const likeFetch = () => {
    resetUnLikeState();
    performLike({ extUuid });
  };

  const unLikeFetch = () => {
    resetLikeState();
    perfromUnLike({ extUuid });
  };

  useEffect(() => {
    const respCode = R.prop("respCode", likeState);
    if (respCode === 0) {
      setHadLike(R.T);
      setLikeNum(likeNum + 1);
    }
  }, [likeState.respCode]);

  useEffect(() => {
    const respCode = R.prop("respCode", unLikeState);
    if (respCode === 0) {
      setHadLike(R.F);
      setLikeNum(likeNum - 1);
    }
  }, [unLikeState.respCode]);

  const clickLike = useCallback(() => {
    if (!ishadLike) {
      return getTT((TT) => TT.sudo(likeFetch));
    } else {
      return getTT((TT) => TT.sudo(unLikeFetch));
    }
  }, [ishadLike]);

  return (
    <>
      <div
        className={classnames(
          styles["ext-star"],
          styles[ishadLike ? "hadLike" : ""]
        )}
        onClick={clickLike}
      >
        <i className={styles["icon-star"]}></i>
        <span className={styles["star-num"]}>{`${likeNum}`}</span>
      </div>
    </>
  );
}

export default Like;
